import { render, staticRenderFns } from "./AlbumPhotoGallery.vue?vue&type=template&id=14fa4739&scoped=true&"
import script from "./AlbumPhotoGallery.vue?vue&type=script&lang=js&"
export * from "./AlbumPhotoGallery.vue?vue&type=script&lang=js&"
import style0 from "./AlbumPhotoGallery.vue?vue&type=style&index=0&id=14fa4739&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14fa4739",
  null
  
)

export default component.exports
import {QDialog,QLayout,QHeader,QBtnGroup,QBtn,QPageContainer} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QDialog,QLayout,QHeader,QBtnGroup,QBtn,QPageContainer})
